import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  LinearProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store/store";
import {
  setCurrentLessonProgress,
} from "../../features/userProgress/userProgressSlice";
import { Modal, Button, Typography } from "../common";
import LogoImg from "../../images/LogoImg";
import { AppHomeButton } from "@pedagogue/ui-core";

const APP_HOME_URL = process.env.REACT_APP_APP_HOME_URL || "https://app.pedagogue.io";

const LessonAppBar: React.FC = () => {
  const bannerOffset = process.env.REACT_APP_ENVIRONMENT_LABEL?.trim() ? { top: 32 } : undefined;
  const { currentLessonProgress } = useSelector(
    (state: RootState) => state.userProgress
  );
  const dispatch = useDispatch();
  const [openConfirmEndLessonModal, setOpenConfirmEndLessonModal] =
    useState<boolean>(false);
  const navigate = useNavigate();

  const handleClickEndLesson = () => {
    if (currentLessonProgress > 0) {
      setOpenConfirmEndLessonModal(true);
    } else {
      navigate(-1);
    }
  };

  const handleEndLesson = () => {
    dispatch(setCurrentLessonProgress(0));
    navigate(-1);
  };

  return (
    <>
      <AppBar position="fixed" sx={bannerOffset}>
        <Toolbar className="bg-white text-black flex items-center lg:px-64">
          <div className="flex items-center gap-2 shrink-0">
            <AppHomeButton url={APP_HOME_URL} />
            <LogoImg href="/" className="block" />
          </div>
          <div className="min-w-0 flex-1 px-2 sm:px-8">
            <LinearProgress
              variant="determinate"
              value={currentLessonProgress}
            />
          </div>
          <div className="flex items-center shrink-0 pr-0 sm:pr-4">
            <Button
              disabled={currentLessonProgress === 100}
              onClick={handleClickEndLesson}
              size="large"
              className="max-sm:!px-3 max-sm:!py-2"
              variant="text"
              startIcon={<CloseIcon sx={{color:"rgb(var(--pd-mist))"}} />}
            />
          </div>
          
        </Toolbar>
      </AppBar>

      <Modal
        activeModal={openConfirmEndLessonModal}
        onClose={() => setOpenConfirmEndLessonModal(false)}
        title="End unit?"
        footerContent={
          <>
            <Button variant="filled" onClick={() => setOpenConfirmEndLessonModal(false)}>
              Keep learning
            </Button>
            <Button variant="danger" onClick={handleEndLesson}>
              Yes, leave
            </Button>
          </>
        }
      >
        <Typography variant="h6" className="leading-7" >
          Are you sure you want to leave? You will lose your progress from this lesson.
        </Typography>
      </Modal>
    </>
  );
};

export default LessonAppBar;
